<template>
    <div>
        <el-row style="display: flex;">
            <el-select v-model="query.sub_type" placeholder="类型" size="mini" clearable>
                <el-option v-for="item in identityOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
            <el-date-picker size="mini" v-model="query.created_at1" type="date"
                value-format="yyyy-MM-dd" placeholder="请选择开始日期">
            </el-date-picker>
            ~
            <el-date-picker size="mini" v-model="query.created_at2" type="date"
                value-format="yyyy-MM-dd" placeholder="请选择结束日期">
            </el-date-picker>
            <el-button type="primary" size="mini" @click="query.page = 1; getList()">搜索</el-button>
            <el-button type="primary" size="mini" @click="handleExport">导出</el-button>
        </el-row>

        <el-row>
            <el-table v-loading="loading" :data="list" border size="mini" :stripe="true"
                style="width: 100%; margin: 10px 0">
                <el-table-column prop="id" label="ID" align="center" min-width="5%"></el-table-column>
                <el-table-column prop="sub_type_name" label="类型" align="center" min-width="8%"></el-table-column>
                <el-table-column prop="amount" label="金额" align="center" min-width="8%"></el-table-column>
                <el-table-column prop="created_at" label="时间" align="center" min-width="12%"></el-table-column>

                <el-table-column prop="order_no" label="订单号" align="center" min-width="15%"></el-table-column>
                <el-table-column prop="event_user_nickname" label="购买者昵称" align="center" min-width="12%"></el-table-column>
                <el-table-column prop="event_user_mobile_phone" label="手机号" align="center" min-width="8%"></el-table-column>
                <el-table-column prop="order_amount" label="订单金额" align="center" min-width="6%"></el-table-column>
            </el-table>
        </el-row>
        <el-row>
            <div class="block">
                <el-pagination background @current-change="getList" :current-page.sync="query.page"
                    :page-size="query.limit" layout="total, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </el-row>
    </div>
</template>

<script>
import { getRevenueLogList } from "@/api/luminaryplan"

export default {
    data: function () {
        return {
            list: [],
            loading: false,
            total: 0,
            query: {
                user_id:this.$route.query.user_id,
                sub_type: "",
                page: 1,
                limit: 10,
                created_at1: "",
                created_at2: "",
            },
            identityOptions: [
              { value: '', label: "全部" },
              { value: '1', label: "收入" },
              { value: '3', label: "提现拒绝返还" },
              { value: '21', label: "提现" },
              { value: '22', label: "订单退款" },
          ],
        };
    },
    created: function () {
        this.getList();
    },
    methods: {
        getList () {
            this.loading = true;
            getRevenueLogList(this.query).then((response) => {
                this.list = response.data.list;
                this.total = response.data.total;
                this.loading = false;
            });
        },
      handleExport() {
        console.log("导出数据");
        const params = new URLSearchParams();
        const fullUrl = window.location.origin;
        // 遍历 queryForm，只添加有值的参数
        Object.entries(this.query).forEach(([key, value]) => {
          if (value !== null && value !== undefined) {
            params.append(key, value);
          }
        });
        // https://dev.backend.zhangdefenspace.com/ https://backend.zhangdefenspace.com/
        const url = `${fullUrl}/backend/activity/luminary/exportRevenueLogList?${params.toString()}`;
        console.log(url);
        // window.open(url, '_blank');
        location.href = url;
      },
    }
}
</script>

<style></style>